import { Box, HStack, Text } from '@chakra-ui/react';
import { Panel, PanelHeader, PanelHeading } from '@gamma/ui/layout';
import ChatSharpIcon from '@gamma/ui/icons/ChatSharpIcon';
import { i18n } from '@investigator/shared/localization';
import { EntityCommunicationProvider } from '../../context';
import { EntityCommunicationPodVariant } from '../../types/entityCommunication';
import { ConnectionArrow } from './ConnectionArrow';
import { EntityCommunicationCard } from './EntityCommunicationCard';

const modalCopy = i18n.pages.entities.entityAnalysisModal;

export const EntityCommunicationSection = (): JSX.Element => {
  return (
    <EntityCommunicationProvider>
      <Panel w="100%">
        <PanelHeader mb={0}>
          <PanelHeading>
            <HStack spacing={2}>
              <ChatSharpIcon />
              <Text>{modalCopy.entityCommunication.title}</Text>
            </HStack>
          </PanelHeading>
        </PanelHeader>
        <Box p={4}>
          <HStack spacing={0} align="center" justify="center">
            <EntityCommunicationCard
              variant={EntityCommunicationPodVariant.INBOUND}
            />
            <ConnectionArrow />
            <EntityCommunicationCard
              variant={EntityCommunicationPodVariant.CURRENT}
            />
            <ConnectionArrow />
            <EntityCommunicationCard
              variant={EntityCommunicationPodVariant.OUTBOUND}
            />
          </HStack>
        </Box>
      </Panel>
    </EntityCommunicationProvider>
  );
};
